import Default from './drawer.default'
import { DrawerProps } from './types'

const Drawer = (props: DrawerProps) => <Default {...props} />

Drawer.Default = Default

export default Drawer
